import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Headers from "@/component/Headers";
import TurnsPill from "@/component/TurnsPill";
import PATH from '@/config/PATH';
import { getDailyPrizeStatus } from '@/Redux/futures/daily-reward/actions';
import { curDailyPrize, curIsMaster } from "@/Redux/selector";
import dailyRewardBgMaster from "@assets/web-v3-images/daily-reward-bg-master.png";
import dailyRewardBg from "@assets/web-v3-images/daily-reward-bg.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router';
import CountdownBar from "./components/CountdownBar";
import GuessPriceCard from './components/GuessPriceCard';
import PrizeNameRibbon from "./components/PrizeNameRibbon";
import QuickRule from './components/QuickRule';
import WinRewardSection from "./components/WinRewardSection";
import PrizeShowcase from './components/PrizeShowcase';

const DailyReward = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const isMaster = useSelector(curIsMaster);
  const { dailyPrizeStatus } = useSelector(curDailyPrize);

  useEffect(() => {
    dispatch(getDailyPrizeStatus({}));
  }, [dispatch]);

  const dataPrizeShowcase = {
    "name": dailyPrizeStatus?.illustrative_item?.name,
    "image": dailyPrizeStatus?.illustrative_item?.image_url
  }

  return (
    <div
      className={`${isMaster ? "bg-[#d93c16]" : "bg-[#fea35d]"} relative flex flex-1 flex-col pb-8 px-4 md:px-8`}
    >
      <div
        style={{
          backgroundImage: `url(${isMaster ? dailyRewardBgMaster : dailyRewardBg})`,
        }}
        className="bg-size-[100%_auto] bg-no-repeat bg-top min-h-screen absolute inset-0 z-1 top-0"
      />
      <Headers
        title={t("daily_reward.daily_reward")}
        titleColor={isMaster ? "#FFFFFF" : "#713B12"}
        className="!px-0 !pt-4 sm:!pt-12"
        iconSizeCustom='!w-8 sm:!w-16'
      />
      <div className="relative z-2 flex flex-1 flex-col sm:pt-6">
        <div className="mt-2 ml-3 flex justify-end relative z-10">
          <TurnsPill turns={dailyPrizeStatus?.turn_balance || 0} onAddTurns={() => navigate(PATH.PACKAGE)} />
        </div>

        <div className="relative z-2 mt-[2vw] mb-[-14vw]">
          <PrizeNameRibbon name={dailyPrizeStatus?.illustrative_item?.name || ""} />
        </div>

        <PrizeShowcase prize={dataPrizeShowcase || {}} isDailyReward endsAt={dailyPrizeStatus?.close_time} />

        {/* <div className="relative z-3 mt-[-14vw] sm:mt-[2%]"> */}
        {/* <CountdownBar endsAt={dailyPrizeStatus?.close_time} /> */}
        {/* </div> */}

        <div className="flex flex-col gap-6 pt-0 sm:pt-20">
          <GuessPriceCard
            product={{ turn_balance: dailyPrizeStatus?.turn_balance }}
            isMaster={isMaster}
          />
          <WinRewardSection tiers={dailyPrizeStatus?.win_reward || []} />
          <QuickRule data={dailyPrizeStatus?.quick_rule || {}} />
        </div>
      </div>
    </div>
  );
};

export default DailyReward;
